module.exports = __webpack_public_path__ + "static/RST-Temperaturfuehler-mit-MU101-ef6e176ddabff5cce60d35b534eb7c34.jpg";